import React, { memo, forwardRef } from "react";
const SvgMu = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.152 8.008v9.312c0 .32-.072.576-.216.768-.128.192-.264.312-.408.36a1.359 1.359 0 01-.432.072c-.16 0-.312-.024-.456-.072-.144-.048-.288-.168-.432-.36-.128-.192-.192-.448-.192-.768v-.864h-.048c-.32.64-.816 1.168-1.488 1.584-.672.4-1.416.6-2.232.6-.816 0-1.48-.24-1.992-.72v5.112c0 .464-.12.784-.36.96-.24.192-.496.288-.768.288s-.528-.096-.768-.288c-.24-.176-.36-.496-.36-.96V8.008c0-.464.12-.784.36-.96.24-.192.496-.288.768-.288s.528.096.768.288c.24.176.36.496.36.96v5.256c0 2.32.864 3.48 2.592 3.48.896 0 1.624-.344 2.184-1.032.576-.688.864-1.592.864-2.712V8.008c0-.464.12-.784.36-.96.24-.192.496-.288.768-.288s.528.096.768.288c.24.176.36.496.36.96z"
      />
    </svg>
  );
});
SvgMu.displayName = "SvgMu";
const MemoForwardRef = memo(SvgMu);
export default MemoForwardRef;
